export default () => {
    
    const print_button = document.querySelector('.btn-print-content');

    if (!print_button) return;
    
    print_button.addEventListener('click', function() {
        window.print();
    });
};
